import { CheckboxProps } from '@mui/material/Checkbox'

import * as S from './styles'

const CheckboxComponent = (props: CheckboxProps) => {
  return (
    <S.CheckboxStyled
      sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
      {...props}
    />
  )
}

export { CheckboxComponent }
